import React, { useEffect, useState } from "react";
import PeopleCard from "./PeopleCard";
import axios from 'axios';
import { useAtom } from "jotai";
import { usersAtom } from "../atoms/ChatAtom";
import { url } from "../../../url";

const People = () => {
  const [users,setUsers] = useAtom(usersAtom);
  const [conversationUsers, setConversationUsers] = useState<any[]>([]);
  
  useEffect(()=>{
    const fetchConversationUsers = async()=>{
      try {
        // Pobierz wszystkich użytkowników
        const usersResponse = await axios.get(url + "/user/users",{
          headers: {
            "Content-Type": "application/json", 
            "Authorization": "Bearer "+ localStorage.getItem("token")
          }
        });

        const allUsers = usersResponse.data.users;
        const currentUserId = localStorage.getItem("token");
        
        // Sprawdź konwersacje dla każdego użytkownika
        const usersWithConversations = [];
        
        for (const user of allUsers) {
          try {
            const conversationResponse = await axios.get(url + `/chat/conversation?friendId=${user._id}`, {
              headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + currentUserId
              }
            });
            
            // Jeśli konwersacja ma wiadomości, dodaj użytkownika
            if (conversationResponse.data.conversation.messages && 
                conversationResponse.data.conversation.messages.length > 0) {
              usersWithConversations.push(user);
            }
          } catch (error) {
            // Ignoruj błędy dla pojedynczych użytkowników
            console.log(`No conversation with user ${user._id}`);
          }
        }
        
        setConversationUsers(usersWithConversations);
        setUsers(usersWithConversations);
      } catch (error) {
        console.error("Error fetching conversation users:", error);
        setConversationUsers([]);
        setUsers([]);
      }
    };

    fetchConversationUsers();
  },[]);
  
  return (
    <div className="conversations__container__people">
      <p className="conversations__container__people__head">All Message</p>
      {
        conversationUsers.length > 0 ? (
          conversationUsers.map((user: any)=> <PeopleCard key={user._id} user={user}/>)
        ) : (
          <div style={{ textAlign: 'center', padding: '2rem', color: '#666' }}>
            <p>No messages</p>
            <p style={{ fontSize: '0.9rem' }}>Start chatting with someone to see them here</p>
          </div>
        )
      }
    </div>
  );
};

export default People;
